import type { RouteRecordRaw } from 'vue-router';

const i18n = import.meta.glob<{ default: Record<string, unknown> }>('./i18n/*.ts');

export const setupStoreRoutes = {
  name: 'store',
  path: 'setup/store',
  component: () => import('./SetupStore.vue'),
  meta: { i18n },
} satisfies RouteRecordRaw;
